import React from 'react';
import autobind from 'autobind-decorator';

import { PureComponent, Page } from 'core/components';
import { Welcome } from 'content/components';

class WelcomePage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      items: []
    };
  };

  render() {
    return (
      <Welcome
        showBack={false}
        navigate={this.props.navigate}
      />
    );
  };
};

export default autobind(WelcomePage);
